import React from 'react';
import styles from './CustomizeCardsSection.module.less';
import CardComponent, { Feature } from './CardComponent';
import { HeadingText } from '@paypalcorp/pp-react';

type ContentJson = {
  recommendedFeatures: Array<Feature>;
  featureList: Array<Feature>;
};

type EcmContent = {
  content: string;
  contentJson: ContentJson;
};

type CustomizeCardsSectionProps = {
  ecmContent: EcmContent;
};

const CustomizeCardsSection = ({ ecmContent }: CustomizeCardsSectionProps) => {
  const { content, contentJson } = ecmContent;
  const { recommendedFeatures = [], featureList } = contentJson;

  return (
    <div className={styles.container}>
      <div
        dangerouslySetInnerHTML={{
          __html: content
        }}
      />
      <div className={styles.features_list}>
        <div className={styles.recommended}>
          {recommendedFeatures.length > 0 && (
            <HeadingText className={styles.features_wrapper} size="sm" type="medium">
              Recommended features:
            </HeadingText>
          )}
          {recommendedFeatures.map((feature) => (
            <CardComponent key={feature.title} feature={feature} />
          ))}
        </div>
        {featureList.map((feature) => (
          <CardComponent key={feature.title} feature={feature} />
        ))}
      </div>
    </div>
  );
};

export default CustomizeCardsSection;
